// §4.4 partial — dev-only smoke route. Production leaves `/` to dashboard.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const routes: RouteObject[] = import.meta.env.PROD
  ? []
  : [
      {
        path: "/_smoke",
        Component: lazyWithRetry(() => import("./pages/SmokePage")),
      },
    ];

export default routes;
